export const getButtonConfig = (data, onlyConnect) => {
  if (data.has_invalid_token) {
    return {
      type: "primary",
      icon: "arrows_rotate",
      text: "Update token"
    }
  }

  if (data.service_name === "manual_refunds") {
    return {
      icon: null,
      text: data.is_connected ? "Selected" : "Select"
    }
  }

  if (data.isRequestIntegration) {
    return {
      icon: "plus",
      text: "Request integration"
    }
  }

  if (data.isDisabled) {
    return {
      icon: onlyConnect ? "plugin_connected" : "calendar_clock",
      text: data.disabledStatus
    }
  }

  // Custom CTA (e.g. "Set up manually" for the Custom MCP card).
  if (data.ctaText) {
    return {
      icon: data.ctaIcon ?? null,
      text: data.ctaText
    }
  }

  return {
    icon: data.is_connected ? "circle_x" : "plugin_connect",
    text: data.is_connected ? "Disconnect" : "Connect"
  }
}
